import { Tooltip } from '@mui/material'
import React, { forwardRef } from 'react'

const TooltipWrapper = forwardRef(({ children, ...props }, ref) => (
  <span ref={ref} {...props}>
    {children}
  </span>
))

export const MyTooltip = ({ children, ...props }) => {
  return (
    <>
      <Tooltip placement='top' {...props}>
        <TooltipWrapper>{children}</TooltipWrapper>
      </Tooltip>
    </>
  )
}
